export enum MarkersType {
  Install = 'install',
  Replace = 'replace',
}
